export default __webpack_public_path__ + "static/odu-3285fb063f09aadaa7ecbc58fa5f6d0d.png";